export const accountTypeValues = [
  "SAVINGS",
  "TRANSACTION",
  "FIXED_INCOME_FUND",
  "FX",
  "NOTICE_ACCOUNT",
  "TERM_DEPOSIT",
] as const;

export const accountsGroupKindInputValues = [
  "BUSINESS_ENTITY",
  "PROVIDER",
  "CURRENCY",
  "ACCOUNT_TYPE",
  "ASSET_CLASS",
] as const;

export const achAccountTypeValues = ["CHECKING", "SAVINGS"] as const;

export const activityStatementFormatValues = ["NETSUITE", "XERO"] as const;

export const airwallexConnectionStatusValues = [
  "INITIALISING",
  "ACTIVE",
  "DELETED",
  "RECONNECT_REQUIRED",
] as const;

export const alertRuleUserTaskActionTypeValues = ["TOP_UP", "SWEEP"] as const;

export const approvalRequestResultValues = [
  "APPROVED",
  "PENDING",
  "REJECTED",
] as const;

export const approvalReviewDecisionValues = ["APPROVED", "REJECTED"] as const;

export const assetClassValues = [
  "EXTERNAL_BANK_ACCOUNT",
  "FIXED_INCOME_FUND",
  "FX",
  "NOTICE_ACCOUNT",
  "SAVINGS",
  "TERM_DEPOSIT",
] as const;

export const assetLedgerAccountKindValues = [
  "BALANCE",
  "INCOMING",
  "OUTGOING",
  "PROVIDER_FEES",
  "PROVIDER_INCOME",
  "UNCATEGORIZED",
] as const;

export const assetRebalanceFXExecutionModeValues = [
  "DEFERRED",
  "IMMEDIATE",
] as const;

export const assetRebalanceKindValues = [
  "REBALANCE",
  "WITHDRAWAL",
  "TRANSFER_INTERNAL",
  "TRANSFER_WITHDRAWAL",
] as const;

export const assetRuleEvaluationCadenceValues = [
  "DAILY",
  "WEEKLY",
  "MONTHLY",
] as const;

export const assetRuleEvaluationStatusValues = ["HEALTHY", "BREACH"] as const;

export const assetRuleStatusValues = ["ACTIVE", "INACTIVE"] as const;

export const assetRuleTypeValues = [
  "TOP_UP",
  "RECURRING_WITHDRAWAL",
  "ALERT",
] as const;

export const assetStatusValues = [
  "ACTIVE",
  "CLOSED",
  "HOLDING",
  "MATURED",
  "PENDING",
  "SCHEDULED",
  "DISABLED",
  "DELETED",
] as const;

export const balanceForecastTimeSeriesIntervalValues = [
  "WEEK",
  "FORTNIGHT",
] as const;

export const balanceTimeseriesRangeValues = [
  "ONE_MONTH",
  "SIX_MONTHS",
  "ONE_YEAR",
] as const;

export const beneficiaryAccountKindValues = [
  "VERIFIED_BENEFICIARY",
  "PAYEE",
] as const;

export const beneficiaryAccountStatusValues = [
  "ACTIVE",
  "CLOSED",
  "DELETED",
  "DISABLED",
  "INITIAL",
  "PENDING",
] as const;

export const blackrockOrderKindValues = ["APPLICATION", "REDEMPTION"] as const;

export const brexConnectionStatusValues = [
  "INITIALISING",
  "ACTIVE",
  "INACTIVE",
  "RECONNECT_REQUIRED",
] as const;

export const bypassApprovalRequestReasonValues = [
  "APPROVAL_NOT_APPLICABLE",
  "DO_NOT_BYPASS_APPROVAL_POLICY",
  "TRANSFER_CREATED_RETROACTIVELY",
  "OPERATOR_BYPASSED_POLICY",
] as const;

export const calastoneTransactionStatusValues = [
  "TO_PROCESS",
  "PRICED",
  "VOID",
  "PROCESSED",
] as const;

export const cashflowRangeValues = ["THREE_MONTHS"] as const;

export const createAssetStatusValues = ["ACTIVE", "CLOSED", "PENDING"] as const;

export const createTermDepositApprovalTypeValues = [
  "REQUIRED",
  "BYPASS",
  "BYPASS_WITHOUT_NOTIFYING",
] as const;

export const currencyValues = [
  "AUD",
  "CAD",
  "CNY",
  "EUR",
  "GBP",
  "HKD",
  "JPY",
  "NZD",
  "SGD",
  "USD",
  "MYR",
  "BRL",
] as const;

export const currencyDownsideRiskRatingValues = [
  "NEGLIGIBLE",
  "LOW",
  "MODERATE",
  "HIGH",
] as const;

export const currencycloudAccountStatusValues = [
  "ENABLED",
  "DISABLED",
  "ENABLED_NO_TRADING",
] as const;

export const currencycloudBeneficiaryPaymentTypeValues = [
  "REGULAR",
  "PRIORITY",
] as const;

export const currencycloudPaymentStatusValues = [
  "AWAITING_AUTHORISATION",
  "AUTHORISED",
  "COMPLETED",
  "DELETED",
  "FAILED",
  "NEW",
  "READY_TO_SEND",
  "RELEASED",
  "SUBMITTED",
  "SUSPENDED",
] as const;

export const currencycloudSettlementTypeValues = ["BULK", "NET"] as const;

export const custodyLedgerAccountKindValues = [
  "INCOMING",
  "OUTGOING",
  "UNASSIGNED",
] as const;

export const depositsPageOrderValues = ["DATE_ASC", "DATE_DESC"] as const;

export const eburyClientCreditConditionsKindValues = [
  "SPOT",
  "FORWARD",
] as const;

export const eburyFxTradeReasonValues = [
  "CHARITABLE_AID",
  "PAYMENT_FOR_GOODS",
  "CAPITAL_INVESTMENT",
  "PAYMENT_FOR_SERVICES",
  "REPATRIATION_OF_GOODS",
  "REPATRIATION_OF_SERVICES",
  "PROPERTY_PURCHASE",
  "MORTAGE_REPAYMENT",
  "PROPERTY_RENTAL_OR_MAINTENANCE",
  "SALARY_PAYROLL",
  "TRAVEL_COSTS",
  "LIVING_COSTS",
  "REPAYMENT_OF_LOAN",
  "BALANCE_HEDGING",
  "REPATRIATION_FROM_INVESTMENT",
  "PORTFOLIO_NETTING",
  "NOT_RELATED_TO_GOODS_OR_SERVICES",
  "OTHER",
] as const;

export const environmentValues = [
  "DEVELOPMENT",
  "STAGING",
  "PRODUCTION",
] as const;

export const estimatedReturnsCalculatorPayoutFrequencyValues = [
  "WEEKLY",
  "FORTNIGHTLY",
  "MONTHLY",
  "QUARTERLY",
  "YEARLY",
] as const;

export const externalBankAccountDataSourceValues = [
  "SISS",
  "QUILTT",
  "AKAHU",
  "SALT_EDGE",
  "SKRIPT",
  "STRIPE",
  "MERCURY",
  "AIRWALLEX",
  "BREX",
  "RAMP",
] as const;

export const fXHedgeKindValues = ["FIXED_FORWARD", "WINDOW_FORWARD"] as const;

export const fXOnboardingRequestStatusValues = [
  "PENDING",
  "ACCOUNT_OPENED",
  "CANCELLED",
] as const;

export const fXRateRangeValues = [
  "ONE_DAY",
  "ONE_WEEK",
  "ONE_MONTH",
  "THREE_MONTHS",
  "SIX_MONTHS",
  "ONE_YEAR",
] as const;

export const fXRateSamplePeriodValues = [
  "MONTH",
  "WEEK",
  "DAY",
  "HOUR",
  "THIRTY_MINUTE",
  "FIFTEEN_MINUTE",
  "FIVE_MINUTE",
  "MINUTE",
] as const;

export const fXTradeDatePreferenceValues = [
  "DEFAULT",
  "EARLIEST",
  "NEXT_DAY",
  "OPTIMIZE_LIQUIDITY",
] as const;

export const fXTradeFundDestinationValues = [
  "TRANSFER_OUT",
  "PAYOUT",
  "WALLET",
] as const;

export const fXTradeFundSourceValues = ["TRANSFER_IN", "WALLET"] as const;

export const fXTradeOperationValues = ["BUY", "SELL"] as const;

export const fXTradeStatusValues = [
  "CREATED",
  "PLACED",
  "OPEN",
  "CANCELLED",
  "COMPLETED",
  "VOIDED",
] as const;

export const fXTradeTimeLogUpdateKindValues = [
  "CREATED",
  "MARGIN_PAID",
  "DRAWDOWN_REQUESTED",
  "DRAWDOWN_EXECUTED",
] as const;

export const fXTradeTransferGroupKindValues = [
  "FUNDING",
  "WITHDRAWAL",
  "MARGIN",
  "REBALANCE",
  "CONVERSION",
  "DRAWDOWN",
] as const;

export const fXTradeTypeValues = [
  "SPOT",
  "FIXED_FORWARD",
  "WINDOW_FORWARD",
] as const;

export const fileImportKindValues = [
  "MACQUARIE_TRANSACTION_FILE",
  "WESTPAC_TRANSACTION_FILE",
] as const;

export const fundDistributionKindValues = [
  "ACCUMULATING",
  "DISTRIBUTING",
] as const;

export const fundInvestmentStyleValues = ["ACTIVE", "PASSIVE"] as const;

export const fundKindValues = ["FIXED_INCOME", "MONEY_MARKET"] as const;

export const importFilePageOrderValues = ["DATE_ASC", "DATE_DESC"] as const;

export const ledgerEntryDirectionValues = ["CREDIT", "DEBIT"] as const;

export const ledgerTransactionAnnotationValues = [
  "DIRECT_WITHDRAWAL",
  "PROVIDER_FEE",
  "TAX",
  "YIELD",
  "YIELD_REINVESTMENT",
  "YIELD_REMITTANCE",
  "BALANCE_SYNC",
] as const;

export const ledgerTransactionTypeValues = [
  "BALANCE_SYNC",
  "DEPOSIT",
  "DIRECT_WITHDRAWAL",
  "MARGIN",
  "PAYOUT",
  "PROVIDER_FEE",
  "STATEMENT_FEE",
  "TAX",
  "TRANSFER_BRIDGE",
  "TRANSFER_IN",
  "TRANSFER_OUT",
  "YIELD",
  "YIELD_REINVESTMENT",
  "YIELD_REMITTANCE",
] as const;

export const liquidityClassValues = [
  "CASH",
  "LINKED",
  "RESERVE",
  "STRATEGIC",
] as const;

export const macquarieTransactionImportFilePageOrderValues = [
  "DATE_ASC",
  "DATE_DESC",
] as const;

export const mercuryAccountTypeValues = [
  "MERCURY",
  "EXTERNAL",
  "RECIPIENT",
  "TREASURY",
] as const;

export const orderDirectionValues = ["ASC", "DESC"] as const;

export const organisationApprovalPolicyKindValues = [
  "PAYOUTS",
  "TRANSFERS",
  "THIRD_PARTY_PAYMENTS",
] as const;

export const organisationFeePaymentMethodValues = [
  "INVOICE",
  "DIRECT_DEBIT",
] as const;

export const paymentInstructionFileKindValues = [
  "MACQUARIE_CMA_EGRESS",
  "MACQUARIE_CMA_ACCELERATOR_EGRESS",
  "PERPETUAL_BUNDLE",
  "PERPETUAL_WESTPAC_EGRESS",
] as const;

export const paymentInstructionFileStatusValues = [
  "PENDING",
  "CANCELLED",
  "SUBMITTED_TO_PROVIDER",
] as const;

export const payoutActionKindValues = [
  "CANCELLED",
  "EXECUTION_CANCELLED",
  "EXECUTION_FAILED",
  "EXECUTION_STARTED",
  "EXECUTION_SUCCESSFUL",
  "VALIDATION_FAILED",
  "VALIDATION_SUCCESSFUL",
  "VOIDED",
] as const;

export const payoutAuthorisationFormKindValues = [
  "SSGA_WITHDRAWAL_REQUEST",
] as const;

export const payoutStatusValues = [
  "CANCELLED",
  "COMPLETED",
  "FAILED",
  "IN_PROGRESS",
  "REJECTED",
  "REQUESTED",
  "SCHEDULED",
  "USER_REVIEW_REQUIRED",
  "VOIDED",
] as const;

export const payoutTimeLogUpdateKindValues = [
  "created",
  "status_transition",
  "approval_review",
] as const;

export const payoutsPageOrderValues = ["DATE_ASC", "DATE_DESC"] as const;

export const sissAccountStatusValues = [
  "ACTIVE",
  "APPROVAL_RECEIVED_BY_SISS",
  "APPROVAL_SENT_TO_CLIENT",
  "CANCELLED_BY_SISS",
  "CREATED",
  "DISCONNECTED",
  "CLOSED",
  "PROBLEM",
] as const;

export const skriptArrangementStatusValues = [
  "ACTIVE",
  "EXPIRED",
  "REVOKED",
  "DISCLOSURE_PENDING",
] as const;

export const statementActionKindValues = [
  "PUBLISH",
  "REGENERATE",
  "VOID",
] as const;

export const statementKindValues = ["ACTIVITY", "BALANCE", "MONTHLY"] as const;

export const statementStatusValues = [
  "PUBLISHED",
  "VOIDED",
  "PROCESSING",
  "STAFF_REVIEW_REQUIRED",
] as const;

export const stripeConnectionStatusValues = [
  "INITIALISING",
  "ACTIVE",
  "INACTIVE",
  "RECONNECT_REQUIRED",
] as const;

export const stripePayoutQueueItemStatusValues = [
  "PENDING",
  "PAID",
  "VOIDED",
] as const;

export const stripePayoutStatusValues = [
  "PAID",
  "PENDING",
  "IN_TRANSIT",
  "CANCELED",
  "FAILED",
] as const;

export const termDepositRolloverStrategyValues = [
  "SIMPLE_TERM",
  "TIME_LADDERED",
] as const;

export const transactionExecutionMethodValues = [
  "MANUAL",
  "EBURY_PAYMENT",
  "EBURY_FX_TRADE",
  "CURRENCYCLOUD_PAYMENT",
  "CURRENCYCLOUD_FX_TRADE",
] as const;

export const transactionFileTransactionStatusValues = [
  "NEW",
  "UNKNOWN",
  "EXISTING",
] as const;

export const transactionPageOrderValues = [
  "AMOUNT_ASC",
  "AMOUNT_DESC",
  "EFFECTIVE_AT_ASC",
  "EFFECTIVE_AT_DESC",
] as const;

export const transactionStatusValues = [
  "DRAFT",
  "PENDING",
  "POSTED",
  "VOIDED",
] as const;

export const transactionTypeValues = [
  "BALANCE_SYNC",
  "DEPOSIT",
  "DIRECT_WITHDRAWAL",
  "FUND_TRADE",
  "MARGIN",
  "PAYOUT",
  "PROVIDER_FEE",
  "STATEMENT_FEE",
  "TAX",
  "TRANSFER_IN",
  "TRANSFER_OUT",
  "UNCATEGORISED",
  "YIELD",
  "YIELD_REINVESTMENT",
  "YIELD_REMITTANCE",
] as const;

export const transferActionKindValues = [
  "CANCELLED",
  "VOIDED",
  "EXECUTION_CANCELLED",
  "EXECUTION_FAILED",
  "EXECUTION_STARTED",
  "EXECUTION_SUCCESSFUL",
  "RECONCILIATION_FAILED",
  "RECONCILIATION_SUCCESSFUL",
  "VALIDATION_FAILED",
  "VALIDATION_SUCCESSFUL",
] as const;

export const transferAuthorisationFormKindValues = [
  "SSGA_APPLICATION_REQUEST",
  "SSGA_WITHDRAWAL_REQUEST",
] as const;

export const transferGroupActionKindValues = ["CANCELLED"] as const;

export const transferGroupKindValues = [
  "REBALANCE",
  "REBALANCE_WITHDRAWAL",
  "REBALANCE_PAYMENT",
  "TRANSFER_INTERNAL",
  "TRANSFER_WITHDRAWAL",
] as const;

export const transferGroupPageOrderValues = [
  "CREATED_AT_ASC",
  "CREATED_AT_DESC",
] as const;

export const transferGroupStatusValues = [
  "CANCELLED",
  "COMPLETED",
  "FAILED",
  "IN_PROGRESS",
  "PENDING",
  "REQUESTED",
  "SCHEDULED",
  "USER_REVIEW_REQUIRED",
  "REJECTED",
  "VOIDED",
] as const;

export const transferPageOrderValues = ["DATE_ASC", "DATE_DESC"] as const;

export const transferSideValues = ["SOURCE", "DESTINATION"] as const;

export const transferStatusValues = [
  "CANCELLED",
  "COMPLETED",
  "FAILED",
  "IN_PROGRESS",
  "PENDING",
  "REQUESTED",
  "SCHEDULED",
  "USER_REVIEW_REQUIRED",
  "REJECTED",
  "VOIDED",
] as const;

export const updateAssetStatusValues = ["ACTIVE", "CLOSED", "PENDING"] as const;

export const usAbaValidNetworksValues = ["ACH", "FEDWIRE"] as const;

export const userMfaRequirementValues = ["REQUIRED", "NOT_REQUIRED"] as const;

export const userTaskKindValues = [
  "APPROVAL_REQUEST",
  "GROUPED_APPROVAL_REQUEST",
  "ALERT_RULE",
  "MANAGE_ALLOCATIONS",
  "FX_FUNDING",
  "EXTERNAL_ACCOUNT_RELINKING",
  "GROUPED_EXTERNAL_ACCOUNT_RELINKING",
] as const;

export const userTaskStatusValues = ["OPEN", "DISMISSED", "COMPLETED"] as const;

export const westpacPaymentInstructionStatusValues = [
  "CREATED",
  "SUBMITTED",
  "RECONCILED",
  "VOID",
] as const;

export const xeroAccountLinkChecklistStatusValues = [
  "TODO",
  "COMPLETED",
  "DISMISSED",
] as const;

export const xeroConnectionStatusValues = [
  "INITIALISING",
  "ACTIVE",
  "INACTIVE",
  "RECONNECT_REQUIRED",
] as const;
